module.exports = __webpack_public_path__ + "static/img/Dylan-Lucas.244d279.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dylan-Lucas.jpg
// module id = PNgF
// module chunks = 0